import { useMutation } from '@occc-app/dataAccessLayer/utils';
import {
  useCreateScanDataSftpCredentialsMutation as useApolloCreateScanDataSftpCredentialsMutation,
  CreateScanDataSftpCredentialsMutationOptions,
} from '@occc/graphql';

export const useCreateScanDataSftpCredentials = (
  baseOptions: CreateScanDataSftpCredentialsMutationOptions,
) => useMutation(useApolloCreateScanDataSftpCredentialsMutation, baseOptions);
